import React, { Fragment } from 'react';

const SuggestionFragment = ({ suggestion }) => (
    <Fragment>
        <img className="suggestion-icon" src={suggestion.getIcon()} alt="icon" height="20" width="20" />
        <div className="suggestion-title">{suggestion.getTitle()}</div>
        <div className="suggestion-datetime">{suggestion.getSubtitle()}</div>
    </Fragment>
);

export default SuggestionFragment;
